import React, { useEffect } from 'react';
import {
  AiOutlinePlusCircle,
  AiOutlineMinusCircle,
  AiOutlinePlayCircle,
  AiOutlinePauseCircle,
} from 'react-icons/ai';
import { RiStopCircleLine } from 'react-icons/ri';
import {
  convertToMilliseconds,
  parseTime,
  handleMinuteButton,
} from '../../utils/timeUtils';

import * as Style from './style';

function TimerPainel({
  currentTime,
  isTimerActive,
  setTimer,
  startTimer,
  resetTimer,
  stopTimer,
  togglePainel,
  // toggleAux,
  timerButtonRef,
  timerPainelRef,
}) {
  const { hours, minutes, seconds } = parseTime(currentTime);

  useEffect(() => {
    const timerPainelElement = timerPainelRef.current;
    const timerButtonElement = timerButtonRef.current;

    const handleMouseDown = ({ target }) => {
      if (
        !timerPainelElement.contains(target) &&
        !timerButtonElement.contains(target)
      ) {
        togglePainel();
      }
    };
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [timerButtonRef, timerPainelRef, togglePainel]);

  return (
    <Style.TimerPainelContainer ref={timerPainelRef}>
      <Style.RelativeTimerContainer>
        <Style.Row>
          <section id="section-interval">
            {!isTimerActive ? (
              <Style.ActionButton
                noBackground
                isDisabled={currentTime <= 0}
                fontSize={1.2}
                type="button"
                onClick={() => setTimer(handleMinuteButton(currentTime, -1))}
              >
                <AiOutlineMinusCircle />
              </Style.ActionButton>
            ) : null}
            <Style.TimerInput
              name="hours"
              value={hours < 10 ? `0${hours}` : hours}
              disabled={isTimerActive || false}
              onChange={({ target }) =>
                setTimer(convertToMilliseconds(target.value, minutes, seconds))
              }
            />
            <span>:</span>
            <Style.TimerInput
              name="minutes"
              disabled={isTimerActive || false}
              value={minutes < 10 ? `0${minutes}` : minutes}
              onChange={({ target }) =>
                setTimer(convertToMilliseconds(hours, target.value, seconds))
              }
            />
            <span>:</span>
            <Style.TimerInput
              name="seconds"
              disabled={isTimerActive || false}
              value={seconds < 10 ? `0${seconds}` : seconds}
              onChange={({ target }) =>
                setTimer(convertToMilliseconds(hours, minutes, target.value))
              }
            />
            {!isTimerActive && (
              <Style.ActionButton
                noBackground
                type="button"
                fontSize={1.2}
                onClick={() => setTimer(handleMinuteButton(currentTime, 1))}
              >
                <AiOutlinePlusCircle />
              </Style.ActionButton>
            )}
          </section>
          {isTimerActive && (
            <section id="minute-chips">
              <Style.Chip
                type="button"
                onClick={() => setTimer(handleMinuteButton(currentTime, 1))}
              >
                +1m
              </Style.Chip>

              <Style.Chip
                type="button"
                onClick={() => setTimer(handleMinuteButton(currentTime, 5))}
              >
                +5m
              </Style.Chip>
            </section>
          )}
        </Style.Row>
        {!isTimerActive && (
          <Style.ActionButton
            noBackground
            type="button"
            fontSize={2}
            onClick={startTimer}
          >
            <AiOutlinePlayCircle />
          </Style.ActionButton>
        )}
        {isTimerActive && (
          <Style.ActionButton
            noBackground
            fontSize={2}
            type="button"
            onClick={resetTimer}
          >
            <RiStopCircleLine />
          </Style.ActionButton>
        )}
        {isTimerActive && (
          <Style.ActionButton
            noBackground
            fontSize={2}
            type="button"
            onClick={() => stopTimer()}
          >
            <AiOutlinePauseCircle />
          </Style.ActionButton>
        )}
        {/* <Style.FloatButton2 type="button" onClick={toggleAux}>
          <AiOutlineClose />
        </Style.FloatButton2> */}
      </Style.RelativeTimerContainer>
    </Style.TimerPainelContainer>
  );
}

export default TimerPainel;
